module.exports = __webpack_public_path__ + "media/application/images/svgs/social/facebook-722750ea2ea84644a36cc535feeed705.svg";